// SPDX-License-Identifier: GPL-2.0-or-later
// Configurações de jogo do Outgun, nas mesmas unidades das variáveis do original (tempos que o
// gamemod recebe em minutos ficam em frames, por exemplo). Defaults = defaults do código
// (`WorldSettings::reset`, `PowerupSettings::reset`, `PhysicalSettings()`, `SettingManager::reset`);
// o preset Clássico aplica `config/gamemod.txt` por cima (decisão D-01).
/** Defaults do código original, antes de qualquer gamemod. */
export function codeDefaults() {
    return {
        world: {
            timeLimit: 0,
            extraTime: 0,
            extraTimePeriods: 1,
            suddenDeath: false,
            captureLimit: 8,
            winScoreDifference: 1,
            respawnTime: 2,
            extraRespawnTimeAlone: 0,
            waitingTimeDeathbringer: 4,
            respawnBalancingTime: 0,
            respawnOnCapture: false,
            shadowMinimum: 7,
            rocketDamage: 70,
            startHealth: 100,
            startEnergy: 100,
            minHealthForRunPenalty: 40,
            healthMax: 300,
            energyMax: 300,
            healthRegeneration0To100: 10,
            energyRegeneration0To100: 10,
            healthRegeneration100To200: 1,
            energyRegeneration100To200: 5,
            healthRegeneration200ToMax: 0,
            energyRegeneration200ToMax: 0,
            runHealthDegradation: 15,
            runEnergyDegradation: 15,
            shootingEnergyBase: 7,
            shootingEnergyPerExtraRocket: 1,
            hitStunTime: 1,
            shootInterval: 0.5,
            shootIntervalWithEnergy: 0.5,
            spawnSafeTime: 0,
            flagReturnDelay: 1,
            balanceTeams: 'no',
            minCaptureTime: 1,
            randomWildFlag: false,
            lockTeamFlags: false,
            lockWildFlags: false,
            captureOnTeamFlag: true,
            captureOnWildFlag: false,
            captureAwayFromBase: false,
            carryOwnTeamFlag: false,
            alwaysSendFlagLocation: false,
            seeRocketsDistance: 0,
            seeMinimapPlayerProperties: 0,
            carryingScoreTime: 0,
        },
        powerups: {
            pupsMin: 20,
            pupsMinPercentage: true,
            pupsMax: 80,
            pupsMaxPercentage: true,
            pupsRespawnTime: 25,
            pupChanceShield: 16,
            pupChanceTurbo: 14,
            pupChanceShadow: 14,
            pupChancePower: 14,
            pupChanceWeapon: 18,
            pupChanceMegahealth: 13,
            pupChanceDeathbringer: 11,
            pupAddTime: 40,
            pupMaxTime: 100,
            pupDeathbringerSwitch: true,
            pupDeathbringerTime: 5,
            pupsDropAtDeath: false,
            pupsPlayerMax: 2147483647, // INT_MAX
            pupHealthBonus: 160,
            pupPowerDamage: 2,
            pupWeaponMax: 9,
            pupShieldHits: 0,
            shadowSeeShadow: false,
            deathbringerHealthLimit: 100,
            deathbringerEnergyLimit: 100,
            deathbringerHealthDegradation: 2.5,
            deathbringerEnergyDegradation: 2.5,
            startShield: false,
            startTurbo: 0,
            startShadow: 0,
            startPower: 0,
            startWeapon: 1,
            startDeathbringer: false,
            teamShield: false,
            teamTurbo: false,
            teamShadow: false,
            teamPower: false,
            teamWeapon: false,
            teamHealth: false,
            teamDeathbringer: false,
        },
        physics: {
            friction: 0.2,
            drag: 0.16,
            acceleration: 2.6,
            brakeMul: 0.1,
            turnMul: 0.5,
            runMul: 1.75,
            turboMul: 1.45,
            flagMul: 0.91,
            rocketSpeed: 50,
            friendlyFire: 0,
            friendlyDeathbringer: 0,
            playerCollisions: 'normal',
            allowFreeTurning: false,
            maxRunSpeed: (1.75 * 2.6 - 0.2) / 0.16, // calc_max_run_speed() no construtor
        },
        server: {
            serverName: 'Anonymous host',
            maxPlayers: null,
            welcomeMessage: [],
            infoMessage: [],
            sayadminEnabled: false,
            sayadminComment: '',
            serverPassword: '',
            saveStats: 0,
            idlekickTime: 1200,
            idlekickPlayerlimit: 4,
            recording: 0,
            spectatingDelay: 15, // D-89 (era 30 pela D-56; o original usa 120)
            logPlayerChat: false,
            rankingMinhumans: 2,
            rankingMinplayers: 4,
            minBots: 0,
            botsFill: 0,
            balanceBot: false,
            botPing: 300,
            botLevel: 4, // `REFERENCE_BOT_LEVEL` de @outgun/bots: o bot do original
            botNameLang: '',
            randomMaprot: 0,
            voteBlockTime: 0,
            requireSpecificMapVote: false,
            gameEndDelay: 5,
            gameEndDelayExtension: 15,
            minimapSendLimit: 32,
        },
        maps: [],
    };
}
//# sourceMappingURL=types.js.map